module.exports = __webpack_public_path__ + "img/chart_word_cloud.f86b1b41.webp";